import { useState } from "react";

function AdminLogin({ setAdminPage }) {
  const [form, setForm] = useState({
    username: "",
    password: ""
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await fetch("https://high-and-fly.onrender.com/admin/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(form)
    });

    const data = await response.json();

    if (data.success) {
      localStorage.setItem("adminToken", data.token);
      setAdminPage("/dashboard");
    } else {
      alert("Invalid credentials");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2>Admin Login</h2>

      <input
        placeholder="Username"
        onChange={(e) => setForm({...form, username: e.target.value})}
      />

      <input
        type="password"
        placeholder="Password"
        onChange={(e) => setForm({...form, password: e.target.value})}
      />

      <button type="submit">Login</button>
    </form>
  );
}

export default AdminLogin;